import { fromEvent, interval, Subject, switchMap, takeUntil, tap } from 'rxjs';
import { Injectable, OnDestroy, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService implements OnDestroy {
  private msalService = inject(MsalService);


  private destroy$ = new Subject<void>();
  private idleTimer$ = new Subject<void>();
  private idleDuration = 30 * 60 * 1000;

  startIdleDetection(idleDurationMinutes: number) {

    this.idleDuration = idleDurationMinutes * 60 * 1000;

    //console.debug(`startIdleTimeoutService: ${idleDurationMinutes} minutes`);

    fromEvent(document, 'mousemove')
      .pipe(
        takeUntil(this.destroy$),
        tap(() => this.resetIdleTimer()),
        switchMap(() => interval(this.idleDuration).pipe(takeUntil(this.idleTimer$))),
        tap(() => {
          this.logout();
        })
      )
      .subscribe();

    fromEvent(document, 'keypress')
      .pipe(
        takeUntil(this.destroy$),
        tap(() => this.resetIdleTimer()),
        switchMap(() => interval(this.idleDuration).pipe(takeUntil(this.idleTimer$))),
        tap(() => {
          this.logout();
        })
      )
      .subscribe();
  }

  resetIdleTimer() {
    //console.debug('resetIdleTimeoutService');
    this.idleTimer$.next();
  }

  private logout() {
    // MSAL does not derive idTokenHint from `account` automatically - it must be passed
    // explicitly, using the raw ID token cached on the account, for B2C to validate
    // postLogoutRedirectUri against the app's registered redirect URIs.
    const account = this.msalService.instance.getActiveAccount();
    this.msalService.logoutRedirect({ account, idTokenHint: account?.idToken });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.idleTimer$.complete();
  }

}
